import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

const ThreeSixtyAnalysisRoute = lazy(() =>
  import('@/features/360-analysis/ThreeSixtyAnalysisRoute').then((m) => ({
    default: m.ThreeSixtyAnalysisRoute,
  })),
);

const analysisSearchSchema = z.object({
  month: z.string().optional(),
});

export const Route = createFileRoute('/app/360-analysis')({
  validateSearch: analysisSearchSchema,
  component: () => (
    <Suspense>
      <ThreeSixtyAnalysisRoute />
    </Suspense>
  ),
});
